/**
 * PrivacyPolicy.js
 * Author: Markus.van.Kempen@gmail.com
 * Date: 2nd Nov 2025
 */

import React from 'react';
import EditablePage from './EditablePage';
import SEO from './SEO';
import { useLanguage } from '../context/LanguageContext';
import { getTranslatedPage } from '../i18n/pages';

export default function PrivacyPolicy() {
  const { language } = useLanguage();
  const tr = getTranslatedPage('privacy-policy', language);
  return (
    <>
      <SEO 
        title={`${tr?.title || 'Privacy Policy'} | Cranford Publications`}
        description={tr?.description || 'Read our privacy policy. Learn how Cranford Publications protects your personal information and respects your privacy.'}
        canonical="/privacy-policy"
        keywords="privacy policy, data protection, personal information"
      />
      <EditablePage pageId="privacy-policy" pageTitle={tr?.title || 'Privacy Policy'} />
    </>
  );
} 